import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFilter, navigationFilter, resetSearchNavigation } from 'src/app/store/navigation';
import { SubSink } from 'subsink';
import { Subject } from 'rxjs';
import { tap, throttleTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'smart-nav-filter',
  templateUrl: './nav-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavFilterComponent implements OnDestroy {

  vm$ = this.store.select(selectFilter);

  private sub = new SubSink();
  private textThrhottle$ = new Subject<string>();

  constructor(private store: Store<any>) {
    this.sub.sink = this.textThrhottle$.pipe(
      throttleTime(300),
      distinctUntilChanged(),
      tap(text => {
        this.store.dispatch(navigationFilter({ text }));
      })
    ).subscribe();
  }

  handleKeyup($event: KeyboardEvent, value: string) {
    this.textThrhottle$.next(value.trim());
    if (this.textFieldEmpty(value)) {
      this.store.dispatch(resetSearchNavigation());
    }
  }

  private textFieldEmpty(value: string) {
    return !value || value.length == 0;
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  clearFilter(vm: any, $event: MouseEvent): void {
    $event.preventDefault();
    vm.text = "";
    this.textThrhottle$.next(vm.text);
    this.store.dispatch(resetSearchNavigation());
  }
}
